import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { map, filter, withLatestFrom } from 'rxjs/operators';
import { Actions } from '../../actions';
import { GetArtistPageSuccess } from '../action-creators';
import { GET_ARTIST_PAGE_SUCCESS } from '../actions';
import AppState from '../../state';
import { UpdatePageField } from '@webapp/store/artist/action-creators';


export const updateArtistDataOnPageEpic = (action$: Observable<Actions>, state$: StateObservable<AppState>) =>
  action$.pipe(
    ofType<Actions, GetArtistPageSuccess>(
      GET_ARTIST_PAGE_SUCCESS
    ),
    filter((action) => !action.page.artist?.id),
    withLatestFrom(state$),
    map(([_, state]) => {
      return new UpdatePageField<'artist'>('artist', state.artist.active);
    })
  );